import React from 'react'

import CommunicationForm from '../components/communications/CommunicationForm'
import useCommunicationsApi from '../hooks/communications/useCommunicationsApi'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function CreateCommunicationPage({ building }) {
  const history = useHistory()
  const [_, { createCommunication }] = useCommunicationsApi()

  return (
    <CommunicationForm
      onSubmit={(values) => {
        createCommunication(values)
      }}
      handleCancel={() => history.push('/comunicaciones')}
      building={building}
    />
  )
}
